// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/styles/" + chunkId + "." + {"5068": "59dd696bd1a578b2","5352": "3f96c0e5368706b2",}[chunkId] + ".css"
}